export const INCIDENT_TYPE_LABELS: Record<string, string> = {
  re1: 'Origin blocking',
  po1: '404 renders',
  sd1: 'Crawler drop',
};

const labelled = new Map<string, string>(Object.entries(INCIDENT_TYPE_LABELS));

export function incidentTypeLabel(incidentType: string): string {
  return labelled.get(incidentType) ?? incidentType;
}
